import { isLibrariesSubSideNavPathname } from '~/utils/isLibrariesSubSideNavPathname';
import { isSearchSubSideNavPathname } from '~/utils/isSearchSubSideNavPathname';

export const isSubSideNavBrowseLastPathname = (pathname: string) =>
  isLibrariesSubSideNavPathname(pathname) || isSearchSubSideNavPathname(pathname);
